import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "@/analytics/ga4";

/**
 * useStartInquiry — returns a memoized handler that fires the (privacy-safe)
 * start_project_click event and routes to the multi-step inquiry flow.
 * The `placement` label is a non-PII scalar used for GA4 attribution.
 */
export function useStartInquiry(placement = "site") {
    const navigate = useNavigate();
    return useCallback(() => {
        trackEvent("start_project_click", { placement });
        navigate("/start");
    }, [navigate, placement]);
}

/**
 * useStartInquiryForPackage — deep-links into the inquiry flow with a package
 * pre-selected (or the package list when no id is available).
 */
export function useStartInquiryForPackage() {
    const navigate = useNavigate();
    return useCallback(
        (pkg) => {
            trackEvent("package_view", { kind: pkg?.kind || "package", item_id: pkg?.id });
            trackEvent("start_project_click", { placement: "package_card" });
            if (!pkg?.id) {
                navigate("/start/package");
                return;
            }
            navigate(`/start/package/${pkg.id}`);
        },
        [navigate]
    );
}
